<template lang="pug">
	.json-editor(v-if="showed")
		.card
			.card-header
				i.fa.fa-pencil
				span {{title || domain}}
				span.last-updated(v-if="domain === 'template' && lastUpdated") Updated {{dayjs(lastUpdated).format('HH:mm MMM-DD')}}
			.card-body
				.loading-wrapper(v-show="state === 'loading'")
					.icon.fa.fa-spinner.fa-spin
					span {{`Fetching ${domain} JSON`}}
				.content(v-show="state === 'loaded'" ref="editorElement")
				.error(v-show="state === 'error'")
					span {{error}}
			.card-footer
				button.btn.btn-secondary(type="button" v-on:click="hide()") Cancel
				button.btn.btn-primary(v-show="state === 'loaded'" type="submit" v-on:click="save()") Save
</template>
<script>
	import Screen 				from './../../mixins/screen';
	import { Template } 		from "@/services/Template";
	import SetupSettings 		from "@/settings/settings.json";
	import JSONEditor 			from 'jsoneditor';
	import dayjs 				from "dayjs";

	export default {
		name: "JsonEditor",
		mixins: [Screen],
		screen: {
			updateOn: [],
			showed: false
		},
		data() {

			this.Template = Template;
			this.dayjs = dayjs;

			return {
				domain: '',
				title: '',
				lastUpdated: '',
				value: '',
				state: 'loading',
				error: ''
			}
		},
		methods: {
			collectData(action, domain, title) {

				this.state = 'loading';
				this.domain = domain;
				this.title = title || '';

				if (!domain) return;

				const fileName = domain ? domain + '.json' : 'websites.json';
				const fileFolder = 'websites';

				const url = `${location.protocol}//${SetupSettings["domain"]}:${location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"]}/${fileFolder}/${fileName}`;

				fetch(url).then(response => {
					this.lastUpdated = response.headers.get('last-modified') || '';
					return response.json();
				}).then(json => {

					this.value = JSON.stringify(json);

					this.editor = new JSONEditor(this.$refs.editorElement, {mode: 'code'});
					this.editor.set(json);

					this.state = 'loaded';

				}).catch(error => {

					this.state = 'error';
					this.error = error;

				});


			},

			save() {


				try {
					JSON.parse(this.editor.getText());
				} catch (error) {
					Broadcast.call("Show Error Notification", ['JSON Validation Error', error.message || error]);
					return;
				}

				this.editor.validate().then(validationResults => {

					if (validationResults.length) {

						Broadcast.call("Show Error Notification", ['JSON Validation Error', validationResults[0].message]);

					} else {

						Template.uploadJsonText(this.editor.getText(), this.domain);

						this.hide();

					}

				});

			}
		}
	}
</script>

<style lang="sass">
	.json-editor
		position: absolute
		z-index: 2000
		background-color: rgba(0, 0, 0, 0.6)
		display: flex
		align-items: center
		justify-content: center
		width: 100%
		height: 100%

		>.card
			width: 80%
			min-height: 500px
			max-height: 80%

			>.card-header
				display: flex
				align-items: center
				gap: 10px

				>.last-updated
					margin-left: auto
					font-size: 80%
					opacity: 0.7

			>.card-body
				height: 500px

				>.content
					height: 100%

				>.loading-wrapper
					height: 100%
					display: flex
					flex-direction: column
					align-items: center
					justify-content: center

					.icon
						display: inline
						font-size: 30px

			>.card-footer
				display: flex
				justify-content: space-between

</style>
